__turbopack_context__.v({
  "alignItemsCenter": "BookDealsCardNew-module__1Nz1FG__alignItemsCenter",
  "authorName": "BookDealsCardNew-module__1Nz1FG__authorName",
  "bookBoxBody": "BookDealsCardNew-module__1Nz1FG__bookBoxBody",
  "bookImage": "BookDealsCardNew-module__1Nz1FG__bookImage",
  "category": "BookDealsCardNew-module__1Nz1FG__category",
  "container": "BookDealsCardNew-module__1Nz1FG__container",
  "dFlex": "BookDealsCardNew-module__1Nz1FG__dFlex",
  "descriptionText": "BookDealsCardNew-module__1Nz1FG__descriptionText",
  "desktopDescription": "BookDealsCardNew-module__1Nz1FG__desktopDescription",
  "imgBox": "BookDealsCardNew-module__1Nz1FG__imgBox",
  "justifyContentSpaceBetween": "BookDealsCardNew-module__1Nz1FG__justifyContentSpaceBetween",
  "mobileDescription": "BookDealsCardNew-module__1Nz1FG__mobileDescription",
  "mobileReviewSec": "BookDealsCardNew-module__1Nz1FG__mobileReviewSec",
  "oldPrice": "BookDealsCardNew-module__1Nz1FG__oldPrice",
  "previewLink": "BookDealsCardNew-module__1Nz1FG__previewLink",
  "pricingBox": "BookDealsCardNew-module__1Nz1FG__pricingBox",
  "pricingDetail": "BookDealsCardNew-module__1Nz1FG__pricingDetail",
  "promoBanner": "BookDealsCardNew-module__1Nz1FG__promoBanner",
  "promoPriceText": "BookDealsCardNew-module__1Nz1FG__promoPriceText",
  "readPreview": "BookDealsCardNew-module__1Nz1FG__readPreview",
  "retailerPriceText": "BookDealsCardNew-module__1Nz1FG__retailerPriceText",
  "reviewCount": "BookDealsCardNew-module__1Nz1FG__reviewCount",
  "reviewSec": "BookDealsCardNew-module__1Nz1FG__reviewSec",
  "siteBox": "BookDealsCardNew-module__1Nz1FG__siteBox",
  "siteListing": "BookDealsCardNew-module__1Nz1FG__siteListing",
  "star": "BookDealsCardNew-module__1Nz1FG__star",
  "titleText": "BookDealsCardNew-module__1Nz1FG__titleText",
});
